
import { BaseModulePublicApi } from "../../base/BaseModulePublicApi";

export class PublicCustomerBillingAddressesApi extends BaseModulePublicApi {
  basePath = 'customer_billing_addresses';
};
